import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { CommandPaletteSearchResult } from "components/CommandPalette/types";

import { SEARCH_CONTEXTS_FOR_NAVIGATION, SearchContextsForNavigationItem } from "./gql";

type UseContextSearchForNavigationProps = {
  query: string;
};

const useContextSearchForNavigation = ({
  query,
}: UseContextSearchForNavigationProps): CommandPaletteSearchResult<SearchContextsForNavigationItem> => {
  const { data, previousData, loading } = useQuery(SEARCH_CONTEXTS_FOR_NAVIGATION, {
    variables: {
      input: {
        after: null,
        first: 10,
        fullTextSearch: query,
        predicates: [],
        orderBy: null,
        requestedPage: null,
      },
    },
  });

  const contexts = useMemo(() => {
    return (
      data?.searchContexts?.edges.map((edge) => edge.node) ||
      previousData?.searchContexts?.edges.map((edge) => edge.node) ||
      []
    );
  }, [data, previousData]);

  return {
    items: contexts,
    loading,
    hasMore: !!data?.searchContexts?.pageInfo.hasNextPage,
    isEmpty: contexts.length === 0,
  };
};

export default useContextSearchForNavigation;
